module.exports = __webpack_public_path__ + "img/06.971c17f4.jpg";